import StandardStickerPart from './standard-sticker-part';
import StickerPart from './sticker-part';

export class ClientStickerPart {
  // this approach prevents undesired reinitializations of client window sticker part form components
  // since ngFor's default trackBy will still recognize this object when the client chooses a part type
  instance: ClientStickerPartInstance;
  partType: CLIENT_STICKER_PART_TYPE; // provide a way to tell part types apart in template without having to resort to functions
}

export type ClientStickerPartInstance = StandardStickerPart | StickerPart | {};

export enum CLIENT_STICKER_PART_TYPE {
  STANDARD_STICKER_PART,
  STICKER_PART
}
